import { interopDefault } from '~/utils';
import RouteEnum from '~/enums/RouteEnum';

export default [
  {
    path: '/applicants',
    name: RouteEnum.APPLICANTS.INDEX,
    component: () =>
      interopDefault(
        import(
          /* webpackChunkName: 'tenantmember:applicants.index' */ '~/pages/tenantmember/applicants/index.vue'
        )
      ),
  },
  {
    path: '/applicants/:id',
    name: RouteEnum.APPLICANTS.SHOW,
    component: () =>
      interopDefault(
        import(
          /* webpackChunkName: 'tenantmember:applicants.show' */ '~/pages/tenantmember/applicants/show.vue'
        )
      ),
  },
];
